import { render, staticRenderFns } from "./new_disk.vue?vue&type=template&id=b432dc26&scoped=true&"
import script from "./new_disk.vue?vue&type=script&lang=js&"
export * from "./new_disk.vue?vue&type=script&lang=js&"
import style0 from "./new_disk.vue?vue&type=style&index=0&id=b432dc26&lang=scss&scoped=true&"
import style1 from "./new_disk.vue?vue&type=style&index=1&id=b432dc26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b432dc26",
  null
  
)

export default component.exports